import { makeStyles } from 'tss-react/mui';

const useStylesTablePagination: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tablePagination: {
    marginTop: 15,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('md')]: {
      '& > div': {
        paddingLeft: 16,
        '& > div': {
          flex: 'none',
        },
      },
    },
    [theme.breakpoints.up('md')]: {
      '& > div': {
        marginRight: 60,
      },
    },
  },
  tablePaginationActions: {
    [theme.breakpoints.down('lg')]: {
      '& > button': {
        paddingLeft: 2,
        paddingRight: 0,
      },
      marginLeft: 0,
    },
  },
  tablePaginationSelect: {
    [theme.breakpoints.down('lg')]: {
      marginRight: 2,
      marginLeft: 0,
    },
  },
}));

export default useStylesTablePagination;
